const optionsQueryStringMixin = {
  // components should declare its options and keyword to enable parsing and updating query string

  watch: {
    '$route.query': {
      handler() {
        this.parseOptionsFromQueryString();
      },
    },
    options: {
      handler() {
        this.updateOptionsAndKeywordInQueryString();
      },
      deep: true,
    },
  },
  mounted() {
    this.parseOptionsFromQueryString();
  },
  methods: {
    parseOptionsFromQueryString() {
      if (this.options === undefined && this.keyword === undefined) return;
      const {
        sortBy,
        order,
      } = this.$route.query;
      const page = Number(this.$route.query.page);
      const size = Number(this.$route.query.size);

      if (!Number.isNaN(page)) {
        this.options.page = page;
      }
      if (!Number.isNaN(size)) {
        this.options.size = size;
      }
      this.options.sortBy = sortBy || this.options.sortBy || this.defaultSortBy;
      this.options.order = order || this.options.order || this.defaultOrder;
    },
    updateOptionsAndKeywordInQueryString() {
      if (this.options === undefined && this.keyword === undefined) {
        return;
      }
      const query = { ...this.$route.query };

      Object.entries(this.httpParams).forEach(([k, v]) => {
        if (v !== undefined && v !== null) {
          query[k] = v;
        }
      });
      this.$router.replace({ query }).catch(() => { });
    },
  },
};

export default optionsQueryStringMixin;
